<template lang="pug">
    .component-reveal-set-paid
        reveal(v-if="invoice.status !== 'PAID'", :confirm="true", @confirm="setPaid")
            button.button.warning(v-if="buttons", slot="trigger") Mark as Paid
            a(v-else, slot="trigger") Pay by cash
            h2 Do you really want to Mark as Paid the invoice
                strong INV{{invoice.internal_id}}({{invoice.id}})
</template>
<script type="text/babel">
    import Reveal from "../../Reveal";
    export default{
        name: "InvoiceRevealMarkAsPaid",
        components: {Reveal},
        data(){
            return {}
        },
        created() {
        },
        methods: {
            setPaid(){
                this.$emit('setPaid')
            }
        },
        computed: {},
        props: ['buttons','invoice'],
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InvoiceRevealMarkAsPaid.vue?7fa6f5f2